import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import './LegalPage.css'
import { LEGAL_PAGES } from './legalContent'

type LegalPageKey = keyof typeof LEGAL_PAGES

export default function LegalPage({ pageKey }: { pageKey: LegalPageKey }) {
  const page = LEGAL_PAGES[pageKey]

  return (
    <>
      <Navbar />

      <section className="legal-hero">
        <div className="container legal-hero__inner">
          <h1>{page.title}</h1>
          <p className="legal-hero__summary">{page.summary}</p>

          <div className="legal-meta">
            {page.meta.filter((item) => item.label !== 'URL').map((item) => (
              <div key={item.label} className="legal-meta__item">
                <span className="legal-meta__label">{item.label}</span>
                <span className="legal-meta__value">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="legal-content">
        <div className="container legal-content__inner">
          {page.sections.map((section) => (
            <article key={section.heading} className="legal-section-card">
              <h2>{section.heading}</h2>

              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}

              {section.bullets && (
                <ul>
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              )}
            </article>
          ))}
        </div>
      </section>

      <Footer />
    </>
  )
}